import { SearchableItemModelT } from "@/Common/Models/SearchableItem";
import { APSSForm } from "@/Patient/Models/Forms/Apss/APSSForm";
import { RadPdfFormData } from "./RadPdf/RadPdfFormData";
import { FavoriteForm } from "./FavoriteForms";
import { FormType } from "./FormTypeEnum";

class GenericForm {
    public formName: string;
    public formType: number;
    public formId: string;
    public isFavorite: boolean;

    public isFavoriteForm(): boolean {
        if (cacheStore.FavoriteForms != null)
            return cacheStore.FavoriteForms.some(x => x.FormType == this.formType && x.FormId == this.formId);

        return false;
    }

    public isFavoriteFormCompare(favoritesById: { [id: string]: FavoriteForm[] }): boolean {
        if (favoritesById != null)
            return favoritesById[this.formId]?.some(x => x.FormType == this.formType) ?? false;

        return false;
    }

    public static fromRadPDFForm(form: RadPdfFormData, favoriteFormsByIds: { [id: string]: FavoriteForm[] } = null): GenericForm {
        let gf = new GenericForm();
        gf.formId = form.formId;
        gf.formType = FormType.PDF;
        gf.formName = form.formName;
        gf.isFavorite = favoriteFormsByIds
            ? gf.isFavoriteFormCompare(favoriteFormsByIds) // use lookups for mass loading
            : gf.isFavoriteForm();

        return gf;
    }

    public static fromAPSSForm(form: APSSForm): GenericForm {
        let gf = new GenericForm();
        gf.formId = form.id;
        gf.formType = FormType.APSS;
        gf.formName = form.nom;
        gf.isFavorite = gf.isFavoriteForm();
        return gf;
    }

    public toSearchableItemModelT(): SearchableItemModelT<GenericForm> {
        let searchableItem = new SearchableItemModelT<GenericForm>(this.formName, this.formId, this, this.formName);
        searchableItem.isFavorite = this.isFavorite;
        return searchableItem;
    }
}

export { GenericForm };
